const httpStatusCode = [
  {name:'301 (Moved Permanently)',value:'301'},
  {name:'302 (Previously "Moved temporarily")',value:'302'},
  {name:'403 (Forbidden)',value:'403'},
  {name:'404 (Not Found)',value:'404'},
  {name:'444 (No Response)',value:'444'},
]

const outputFormat = [
  {name:'Auto',value:'auto'},
  {name:'JSON',value:'json'},
]

const taxesTypes = [
  {name:'None',value:''},
  {name:'ABN',value:'ABN'},
  {name:'TIN',value:'TIN'},
  {name:'TFN',value:'TFN'},
  {name:'ACN',value:'ACN'},
  {name:'Tax ID',value:'Tax ID'},
]

const featuresTypes = [
  {name:'Limit',value:'limit'},
  {name:'Basic',value:'basic'},
]

const intervals = [
  {name:'Month',value:'month'},
  {name:'Year',value:'year'},
]

const discountsTypes = [
  {name:'New price',value:'new_price'},
  {name:'Fixed discount',value:'fixed_price'},
  {name:'Percentage discount',value:'percentage'},
]

const discountOperatorOptions = [
  {name:'Greater than or equal to >=',value:'gte'},
  {name:'Greater than >',value:'gt'},
  {name:'Lesser than or equal to <=',value:'lte'},
  {name:'Lesser than <',value:'lt'},
  {name:'Equal to =',value:'eq'},
]

const newVideoTypes = [
 {name:'Video',value:'video'},
  {name:'Document',value:'document'}, 
]

const shellTestTypes = [
  {name:'EWS',value:'ews'},
  {name:'ERM',value:'erm'},
  {name:'EGM',value:'egm'},
]

const shellScriptsTypes = [
  {name:'Run on EWSM root',value:'ewsm'},
  {name:'Run on all websites root',value:'website_all'},
  {name:'Run on specific websites root',value:'website_custom'},
  {name:'Run on ERM root',value:'erm'},
  {name:'Run on EGM root',value:'egm'},
]

const customerCurrencyOptions = [
  {name:'USD',value:'USD'},
  {name:'AUD',value:'AUD'},
  {name:'EUR',value:'EUR'},
  {name:'GBP',value:'GBP'},
  {name:'NZD',value:'NZD'},
  {name:'INR',value:'INR'},
  {name:'CAD',value:'CAD'},
  {name:'MYR',value:'MYR'},
  {name:'ILS',value:'ILS'},
]

const businessOrgTypes = [
  {name:'Individual',value:'individual'},
  {name:'Company',value:'company'},
]

const resourceTypes = [
  {name:'Website',value:'website'},
  {name:'Domain (coming soon)',value:'domain', isDisabled: true},
  {name:'Email (coming soon)',value:'email', isDisabled: true},
]

const dnsProviders = [
  { name:'Staq DNS (Powered by AWS Route53)', value:'staq_dns' },
  { name:'Cloudflare', value:'cloudflare' },
  { name:'Third Party (GoDaddy, Namecheap,...)', value:'3rd_party_dns' },
]

const subRolesTypes = [
  {name:'Team Member',value:'team_member'},
  {name:'Third Party',value:'third_party'},
]

const activityLogsFilters = [
  {name:'ERM',value:'erm'},
  {name:'ERM-AWS',value:'erm-aws'},
  {name:'EWSM',value:'ewsm'},
  {name:'EGM',value:'egm'},
]
const activityLogsServiceTypes = [
  {name:'Any',value:'any'},
  {name:'Process',value:'proc'},
  {name:'Job',value:'job'},
  {name:'HTTP Client',value:'http_client'},
  {name:'Command',value:'command'},
]
const activityLogsServiceDisplayOptions = [
  {name:'Any',value:'any'},
  {name:'Success only',value:'success_only'},
  {name:'Failure only',value:'failure_only'},
]

const countryCodes = {"BD": "Bangladesh", "BE": "Belgium", "BF": "Burkina Faso", "BG": "Bulgaria", "BA": "Bosnia and Herzegovina", "BB": "Barbados", "WF": "Wallis and Futuna", "BL": "Saint Barthelemy", "BM": "Bermuda", "BN": "Brunei", "BO": "Bolivia", "BH": "Bahrain", "BI": "Burundi", "BJ": "Benin", "BT": "Bhutan", "JM": "Jamaica", "BV": "Bouvet Island", "BW": "Botswana", "WS": "Samoa", "BQ": "Bonaire, Saint Eustatius and Saba ", "BR": "Brazil", "BS": "Bahamas", "JE": "Jersey", "BY": "Belarus", "BZ": "Belize", "RU": "Russia", "RW": "Rwanda", "RS": "Serbia", "TL": "East Timor", "RE": "Reunion", "TM": "Turkmenistan", "TJ": "Tajikistan", "RO": "Romania", "TK": "Tokelau", "GW": "Guinea-Bissau", "GU": "Guam", "GT": "Guatemala", "GS": "South Georgia and the South Sandwich Islands", "GR": "Greece", "GQ": "Equatorial Guinea", "GP": "Guadeloupe", "JP": "Japan", "GY": "Guyana", "GG": "Guernsey", "GF": "French Guiana", "GE": "Georgia", "GD": "Grenada", "GB": "United Kingdom", "GA": "Gabon", "SV": "El Salvador", "GN": "Guinea", "GM": "Gambia", "GL": "Greenland", "GI": "Gibraltar", "GH": "Ghana", "OM": "Oman", "TN": "Tunisia", "JO": "Jordan", "HR": "Croatia", "HT": "Haiti", "HU": "Hungary", "HK": "Hong Kong", "HN": "Honduras", "HM": "Heard Island and McDonald Islands", "VE": "Venezuela", "PR": "Puerto Rico", "PS": "Palestinian Territory", "PW": "Palau", "PT": "Portugal", "SJ": "Svalbard and Jan Mayen", "PY": "Paraguay", "IQ": "Iraq", "PA": "Panama", "PF": "French Polynesia", "PG": "Papua New Guinea", "PE": "Peru", "PK": "Pakistan", "PH": "Philippines", "PN": "Pitcairn", "PL": "Poland", "PM": "Saint Pierre and Miquelon", "ZM": "Zambia", "EH": "Western Sahara", "EE": "Estonia", "EG": "Egypt", "ZA": "South Africa", "EC": "Ecuador", "IT": "Italy", "VN": "Vietnam", "SB": "Solomon Islands", "ET": "Ethiopia", "SO": "Somalia", "ZW": "Zimbabwe", "SA": "Saudi Arabia", "ES": "Spain", "ER": "Eritrea", "ME": "Montenegro", "MD": "Moldova", "MG": "Madagascar", "MF": "Saint Martin", "MA": "Morocco", "MC": "Monaco", "UZ": "Uzbekistan", "MM": "Myanmar", "ML": "Mali", "MO": "Macao", "MN": "Mongolia", "MH": "Marshall Islands", "MK": "Macedonia", "MU": "Mauritius", "MT": "Malta", "MW": "Malawi", "MV": "Maldives", "MQ": "Martinique", "MP": "Northern Mariana Islands", "MS": "Montserrat", "MR": "Mauritania", "IM": "Isle of Man", "UG": "Uganda", "TZ": "Tanzania", "MY": "Malaysia", "MX": "Mexico", "IL": "Israel", "FR": "France", "IO": "British Indian Ocean Territory", "SH": "Saint Helena", "FI": "Finland", "FJ": "Fiji", "FK": "Falkland Islands", "FM": "Micronesia", "FO": "Faroe Islands", "NI": "Nicaragua", "NL": "Netherlands", "NO": "Norway", "NA": "Namibia", "VU": "Vanuatu", "NC": "New Caledonia", "NE": "Niger", "NF": "Norfolk Island", "NG": "Nigeria", "NZ": "New Zealand", "NP": "Nepal", "NR": "Nauru", "NU": "Niue", "CK": "Cook Islands", "XK": "Kosovo", "CI": "Ivory Coast", "CH": "Switzerland", "CO": "Colombia", "CN": "China", "CM": "Cameroon", "CL": "Chile", "CC": "Cocos Islands", "CA": "Canada", "CG": "Republic of the Congo", "CF": "Central African Republic", "CD": "Democratic Republic of the Congo", "CZ": "Czech Republic", "CY": "Cyprus", "CX": "Christmas Island", "CR": "Costa Rica", "CW": "Curacao", "CV": "Cape Verde", "CU": "Cuba", "SZ": "Swaziland", "SY": "Syria", "SX": "Sint Maarten", "KG": "Kyrgyzstan", "KE": "Kenya", "SS": "South Sudan", "SR": "Suriname", "KI": "Kiribati", "KH": "Cambodia", "KN": "Saint Kitts and Nevis", "KM": "Comoros", "ST": "Sao Tome and Principe", "SK": "Slovakia", "KR": "South Korea", "SI": "Slovenia", "KP": "North Korea", "KW": "Kuwait", "SN": "Senegal", "SM": "San Marino", "SL": "Sierra Leone", "SC": "Seychelles", "KZ": "Kazakhstan", "KY": "Cayman Islands", "SG": "Singapore", "SE": "Sweden", "SD": "Sudan", "DO": "Dominican Republic", "DM": "Dominica", "DJ": "Djibouti", "DK": "Denmark", "VG": "British Virgin Islands", "DE": "Germany", "YE": "Yemen", "DZ": "Algeria", "US": "United States", "UY": "Uruguay", "YT": "Mayotte", "UM": "United States Minor Outlying Islands", "LB": "Lebanon", "LC": "Saint Lucia", "LA": "Laos", "TV": "Tuvalu", "TW": "Taiwan", "TT": "Trinidad and Tobago", "TR": "Turkey", "LK": "Sri Lanka", "LI": "Liechtenstein", "LV": "Latvia", "TO": "Tonga", "LT": "Lithuania", "LU": "Luxembourg", "LR": "Liberia", "LS": "Lesotho", "TH": "Thailand", "TF": "French Southern Territories", "TG": "Togo", "TD": "Chad", "TC": "Turks and Caicos Islands", "LY": "Libya", "VA": "Vatican", "VC": "Saint Vincent and the Grenadines", "AE": "United Arab Emirates", "AD": "Andorra", "AG": "Antigua and Barbuda", "AF": "Afghanistan", "AI": "Anguilla", "VI": "U.S. Virgin Islands", "IS": "Iceland", "IR": "Iran", "AM": "Armenia", "AL": "Albania", "AO": "Angola", "AQ": "Antarctica", "AS": "American Samoa", "AR": "Argentina", "AU": "Australia", "AT": "Austria", "AW": "Aruba", "IN": "India", "AX": "Aland Islands", "AZ": "Azerbaijan", "IE": "Ireland", "ID": "Indonesia", "UA": "Ukraine", "QA": "Qatar", "MZ": "Mozambique"};

const globalHelper = {
  httpStatusCode,
  outputFormat,
  taxesTypes,
  featuresTypes,
  intervals,
  discountsTypes,
  discountOperatorOptions,
  newVideoTypes,
  shellTestTypes,
  shellScriptsTypes,
  customerCurrencyOptions,
  businessOrgTypes,
  resourceTypes,
  dnsProviders,
  subRolesTypes,
  activityLogsFilters,
  activityLogsServiceTypes,
  activityLogsServiceDisplayOptions,
  countryCodes,
};

export default globalHelper;
